import SimpleQuestion from "./SimpleQuestion";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useState } from "react";
import { useSelector } from "react-redux";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import frLocale from "date-fns/locale/fr";
import enLocale from "date-fns/locale/en-US";
import { getBrokerInformation } from "../store/broker";
import translations from "../utils/translations";
const Date = ({ text, node, handleAnswerChange, isNodeOpen, qfusermode }) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <DatePicker
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></DatePicker>
      }
    ></SimpleQuestion>
  );
};

const DatePicker = ({ node, handleAnswerChange, qfusermode }) => {
  const handleAnswer = (date) => {
    handleAnswerChange(date ? date.toString() : date);
  };

  const [selectedDate, setDate] = useState(node.answer ? node.answer : null);
  const [errorText, setErrorText] = useState("");
  const [rawValue, setRawValue] = useState("");
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const locale = languagepreference === "fr" ? frLocale : enLocale;

  const onDateChange = (date, value) => {
    setDate(date);
    handleAnswer(value);
    setRawValue(value);
  };

  const checkError = (e, v) => {
    if (e === "" && v && errorText.length > 0) {
      setErrorText("");
      return;
    }
    if (
      rawValue &&
      rawValue.replace(/-/g, "").replace(/_/g, "").length === 8 &&
      e !== ""
    ) {
      setErrorText(e);
    }
  };

  const handleBlur = (e) => {
    if (selectedDate === "Invalid Date") {
      setErrorText("Format de date invalide"); // Translated error message
    } else {
      setErrorText("");
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
      <KeyboardDatePicker
        autoOk={true}
        placeholder={languagepreference === "fr" ? "aaaa-mm-jj" : "yyyy-mm-dd"}
        cancelLabel={translations[languagepreference].cancel}
        todayLabel={languagepreference === "fr" ? "Aujourd'hui" : "Today"}
        showTodayButton={true}
        value={selectedDate}
        format="yyyy-MM-dd"
        inputFormat="yyyy-MM-dd"
        inputValue={node.answer ? node.answer : null}
        onChange={onDateChange}
        onError={checkError}
        error={errorText && errorText.length > 0}
        helperText={errorText && errorText.length > 0 ? errorText : null}
        onBlur={handleBlur}
        disabled={qfusermode === INSURER ? true : false}
      />
    </MuiPickersUtilsProvider>
  );
};

export default Date;
